import React, { useCallback, useEffect, useState } from "react";
import { View, Text, Image, BackHandler, Platform } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import * as Location from "expo-location";
import styles from "../../styles/profileStyle";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import { PROFILE_ROUTES } from "../../../../navigation/routes";
import dimensions from "../../../../globalStyles/dimensions";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import CustomComponent from "../../../../components/CustomComponent";
import { Colors } from "../../../../globalStyles/ColorConfig";
import AsyncStorage from "@react-native-async-storage/async-storage";

interface Position {
  coords: {
    latitude: number;
    longitude: number;
    accuracy: number;
    altitude?: number | null;
    altitudeAccuracy?: number | null;
    heading?: number | null;
    speed?: number | null;
  };
  timestamp: number;
}

const GrantLocationAccess = () => {
  const navigation = useNavigation();
  const [location, setLocation] = useState<any | null>(null);
  const [take, setTake] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const nextButtoHandle = async () => {
    // navigation.navigate(PROFILE_ROUTES.ONBOARD_SUBSCRIBE as never);
    navigation.navigate(PROFILE_ROUTES.ONBOARD_ALLDONE as never);
  };

  useFocusEffect(
    useCallback(() => {
      const handleBackButton = () => {
        navigation.navigate(PROFILE_ROUTES.SELECT_EXPERIENCE as never);
        return true;
      };

      const backHandler = BackHandler.addEventListener(
        "hardwareBackPress",
        handleBackButton
      );

      return () => backHandler.remove();
    }, [navigation])
  );

  const setStaticScreenHide = async () => {
    try {
      await AsyncStorage.setItem("hideStaticScreen", "true");
      console.log("Value set in local storage");
    } catch (error) {
      console.error("Error setting value in local storage:", error);
    }
  };

  useEffect(() => {
    setStaticScreenHide();
  }, []);
  return (
    <View style={styles.Wrapper}>
      <View
        style={{
          position: "absolute",
          height: dimensions.windowHeight / 1.5,
          //   width: dimensions.windowWidth * 2.1,
          width: Platform.OS === "web" ? 390 : dimensions.windowWidth * 2.1,
          // backgroundColor: 'red',
          top: 0,
        }}
      >
        <Image
          source={{
            uri: "https://hushl-spark-dev.s3.ap-south-1.amazonaws.com/frontend-assets/onboarding/grantaccess.webp",
          }}
          resizeMode="cover"
          style={{
            width: Platform.OS === "web" ? 390 : "100%",
            height: "100%",
          }}
        />
        <LinearGradient
          colors={["transparent", "rgba(0,0,0,1)"]}
          style={{
            position: "absolute",
            width: "100%",
            height: dimensions.windowHeight / 4,
            bottom: 0,
          }}
        />
      </View>
      <View
        style={{
          position: "absolute",
          bottom: 30,
          width: Platform.OS === "web" ? 390 : dimensions.windowWidth,
          paddingHorizontal: 16,
        }}
      >
        <View style={{}}>
          <Text
            style={[
              styles.showOffText,
              GlobalStyles.heading2,
              { color: "white" },
            ]}
          >
            We would like to know your location, so we can show you the profile
            in your locality
          </Text>
        </View>
        <CustomComponent.AppBtn
          name={"Grant access"}
          style={{
            backgroundColor: Colors.black100,
            borderRadius: 40,
            marginVertical: dimensions.marginVertical,
            borderWidth: 0.5,
            borderColor: Colors.grey300,
            justifyContent: "center",
          }}
          textStyle={[GlobalStyles.bodyText, { color: Colors.white10 }]}
          onPress={nextButtoHandle}
        />
      </View>
      {take && (
        <View style={{ width: "80%", marginTop: 10 }}>
          <Text style={{ color: "red", textAlign: "center" }}>
            You need to give us the location access. Go to settings and grant
            access
          </Text>
        </View>
      )}
    </View>
  );
};

export default GrantLocationAccess;
